// One assessment mode's tab in the product type assessment dialog.
export const T = {
  en_GB: {
    removeQuestion: "Remove question",
    enableQuiz: "Enable quiz",
    enableQuestionnaire: "Enable questionnaire",
    quizHint:
      "Draws a random subset of the questions per attempt, with attempt limits and an optional cooldown.",
    questionnaireHint: "Asks every question inline, answered in one go with no attempt limits.",
    disabledQuiz: "The quiz is off. Turn it on to configure its questions and attempt rules.",
    disabledQuestionnaire: "The questionnaire is off. Turn it on to configure its questions.",
    questions: "Questions",
    question: "Question",
    addQuestion: "Add question",
    editAria: "Edit question",
    incomplete: "Incomplete",
    noQuestions: "No questions yet — add one to begin.",
    minScore: "Pass score",
    minScoreHint:
      "This mode passes when the summed score across its questions is at or above this bar.",
    questionsToAsk: "Questions to ask",
    questionsToAskHint: "Number of questions randomly drawn per attempt.",
    questionsToAskPerCategory: "Questions to ask per category",
    questionsToAskPerCategoryHint:
      "Number of questions randomly drawn from EACH category per attempt.",
    category: "Category",
    maxAttempts: "Max attempts",
    maxAttemptsHint: "Leave empty for unlimited attempts.",
    attemptResetDays: "Attempt reset (days)",
    attemptResetDaysHint:
      "Days after the last attempt when attempts reset. Leave empty to never reset.",
  },
  nb_NO: {
    removeQuestion: "Fjern spørsmål",
    enableQuiz: "Aktiver quiz",
    enableQuestionnaire: "Aktiver spørreskjema",
    quizHint:
      "Trekker et tilfeldig utvalg av spørsmålene per forsøk, med forsøksgrenser og valgfri nullstilling.",
    questionnaireHint: "Stiller alle spørsmålene direkte, besvart i én omgang uten forsøksgrenser.",
    disabledQuiz: "Quizen er av. Slå den på for å konfigurere spørsmål og forsøksregler.",
    disabledQuestionnaire: "Spørreskjemaet er av. Slå det på for å konfigurere spørsmålene.",
    questions: "Spørsmål",
    question: "Spørsmål",
    addQuestion: "Legg til spørsmål",
    editAria: "Rediger spørsmål",
    incomplete: "Ufullstendig",
    noQuestions: "Ingen spørsmål ennå — legg til ett for å begynne.",
    minScore: "Beståttgrense",
    minScoreHint:
      "Denne modusen bestås når den samlede poengsummen for spørsmålene er lik eller over denne grensen.",
    questionsToAsk: "Spørsmål å stille",
    questionsToAskHint: "Antall spørsmål som trekkes tilfeldig per forsøk.",
    questionsToAskPerCategory: "Spørsmål å stille per kategori",
    questionsToAskPerCategoryHint:
      "Antall spørsmål som trekkes tilfeldig fra HVER kategori per forsøk.",
    category: "Kategori",
    maxAttempts: "Maks forsøk",
    maxAttemptsHint: "La stå tom for ubegrensede forsøk.",
    attemptResetDays: "Nullstill forsøk (dager)",
    attemptResetDaysHint:
      "Dager etter siste forsøk når forsøk nullstilles. La stå tom for aldri å nullstille.",
  },
} as const;
